//useDataRoomNotesQuery
import { useQuery, UseQueryOptions } from 'react-query';

import { DataRoomNote, Guid } from '../../models';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';
import { QueryKeys } from '.';

export function useDataRoomNotesQuery(
	guid: Guid | undefined,
	dataRoomUserGuid: Guid | null | undefined,
	options?: Omit<UseQueryOptions<DataRoomNote[], unknown, DataRoomNote[], any>, 'queryKey' | 'queryFn'> | undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.DataRoomUsers.Notes(guid, dataRoomUserGuid),
		() =>
			AxiosUtils.getResponseData<DataRoomNote[]>(
				api.get(CerebroApiEndpoints.DataRoomUsers.Notes(guid, dataRoomUserGuid))
			),
		options
	);
}
